<new-multipass-subscription-video
  *ngIf="videoModalVisible"
  (close)="videoModalVisible = false"></new-multipass-subscription-video>
<div class="modern-notice big-top-buffer" *ngIf="pastDue">
  You can't switch your plan because your account is past due. Please update your
  <a
    [routerLink]="['/dashboard', 'billing_info', 'edit']"
    [queryParams]="{
      editing: true,
      returnUrl: '/dashboard/' + customer?.id + '/multipass-plan'
    }">
    payment info
  </a>
  or contact support for assistance.
</div>

<div class="big-top-buffer text-center" *ngIf="customer?.subscription?.state === 'canceled'">
  <h3>Subscription Status: Canceled</h3>
  <p>
    You will have access to your submissions until
    {{ fullDayWithYear(dashboardAccessUntil()) }}.
  </p>
  <p>
    If you wish to receive submissions past that date just click the button below and your
    subscription will continue as normal.
  </p>
  <button
    type="submit"
    class="btn btn-primary"
    [disabled]="isSaveButtonDisabled"
    (click)="handleReactivateSubscription()">
    {{ 'Reactivate Subscription' + (isSaveButtonDisabled ? ' ...' : '') }}
  </button>
</div>

<div
  class="container-fluid plan-form mt-1 custom-overflow text-center pb-5"
  *ngIf="priceList && !pastDue && customer?.subscription?.state !== 'canceled'">
  <div class="row">
    <div class="col text-center">
      <h3 class="mt-4">{{ mainTitle }}</h3>

      <p
        *ngIf="customer?.scheduledSubscription"
        class="text-center fs-5 px-4 py-2 my-4"
        style="background: #e5f2ff; border-radius: 4px">
        You've scheduled the following plan to take effect on
        {{ moment(customer.scheduledSubscription.currentPeriodStartedAt).format('MMMM Do, YYYY') }}.
        <a
          href="javascript:void(0)"
          (click)="handleCancelChanges()"
          [is-disabled]="isSaveButtonDisabled">
          {{ 'Cancel changes' + (isSaveButtonDisabled ? ' ...' : '') }}
        </a>
      </p>
      <p
        *ngIf="customer?.subscription?.scheduledToCancelAt"
        class="text-center fs-5 px-4 py-2 my-4"
        style="background: #e5f2ff; border-radius: 4px">
        You've scheduled this subscription to cancel on
        {{ moment(customer.subscription.scheduledToCancelAt).format('LL') }}.
        <a href="javascript:void(0)" (click)="handleUndoCancel()" [is-disabled]="isSaveButtonDisabled">
          {{"Undo this change" + (isSaveButtonDisabled ? ' ...' : '')}}
        </a>
      </p>

      <h4 class="mt-3 lato font-weight-light text-no-transform">
        1) Estimate how much content you'll need each month
      </h4>
      <p class="sub-title-step mb-1 mt-2">Toggle the number of pieces.</p>
    </div>
  </div>

  <div class="row" *ngIf="priceListLoaded">
    <div
      class="_col-stack-mobile col-sm-12 col-md p-2"
      [class.disabled-element]="changesScheduled()"
      *ngFor="let code of productCodesToShow; let i = index">
      <div
        class="pricing-box py-4 cursor-pointer"
        [class.selected]="subscriptionConfig.products[code]?.quantity > 0"
        [pass-event-to]="quantitySelectorRef">
        <h4 class="mb-3 text-nowrap">{{ priceList?.products[code]?.words }} Words</h4>
        <quantity-selector
          #quantitySelectorRef
          [min]="0"
          [max]="999"
          [(quantity)]="subscriptionConfig.products[code].quantity"
          (quantityChange)="handleQuantityChange()"></quantity-selector>
        <div class="mt-3">
          <span class="currency">{{ priceList?.products[code]?.formattedValue }}</span>
          <span class="subcurrency">/piece</span>
        </div>
      </div>
    </div>
  </div>
  <p *ngIf="!customWordCounts.length">
    Or choose a
    <a href="javascript:void(0)" (click)="addCustomWordCount()">custom length</a>
  </p>
  <div
    class="row row-cols-xs-1 row-cols-md-4 row-cols-xl-5 align-items-center justify-content-center"
    *ngIf="priceListLoaded">
    <div
      class="_col-stack-mobile col-xs-12 col-md-3 col-lg-3 col-xl-5 p-2 custom-word-col"
      [class.disabled-element]="changesScheduled()"
      *ngFor="let customWordCount of customWordCounts; let i = index">
      <div
        class="d-flex flex-column align-items-center justify-content-center py-4 w-100 pricing-box"
        [class.selected]="customWordCount.quantity > 0"
        [pass-event-to]="quantitySelectorRef">
        <div id="word-counter" class="d-flex flex-column mb-4">
          <div class="d-flex d-row align-items-center justify-content-between">
            <button
              class="btn bg-transparent border-0 custom-word-count-words"
              [is-disabled]="customWordCount.words === 300"
              (click)="decreaseCustomWordCount(customWordCount, i)">
              <i class="fas fa-minus-circle fa-2xl"></i>
            </button>
            <h4 class="text-nowrap m-0 p-0">
              {{ customWordCount.words }}
            </h4>
            <button
              class="btn bg-transparent border-0 custom-word-count-words"
              [is-disabled]="customWordCount.words === 4000"
              (click)="increaseCustomWordCount(customWordCount, i)">
              <i class="fas fa-plus-circle fa-2xl"></i>
            </button>
          </div>
          <h6 class="text-nowrap m-0 p-0 px-2">words</h6>
        </div>
        <quantity-selector
          #quantitySelectorRef
          [min]="0"
          [max]="999"
          [(quantity)]="customWordCount.quantity"
          (quantityChange)="handleQuantityChange()"></quantity-selector>
        <div class="mt-3">
          <span class="currency">{{ customWordCount.formattedValue }}</span>
          <span class="subcurrency">/piece</span>
        </div>
        <div class="d-flex flex-row align-items-center" (click)="deleteCustomWordCount(i)">
          <i class="fas fa-trash-can text-tertiary pr-2"></i>
          <span class="text-tertiary">Remove</span>
        </div>
      </div>
    </div>
    <div
      class="d-flex flex-row align-items-center justify-content-center add-another"
      *ngIf="customWordCounts.length"
      (click)="addCustomWordCount()">
      <i class="fas fa-plus fa-xs text-secondary pr-1 cursor-pointer"></i>
      <span class="text-secondary cursor-pointer">Add another</span>
    </div>
  </div>

  <div
    *ngIf="!quantityErrorMessage"
    class="row border py-3 px-4 mt-4 price-partial justify-content-md-center">
    <div class="col-12">
      <div class="d-flex justify-content-center align-items-center">
        <div class="label">Subtotal:</div>
        <div class="ml-2 font-weight-light">
          <span class="dollars">{{ contentSubtotalFormattedValue }}</span>
        </div>
      </div>
    </div>
  </div>

  <div #section2>
    <ng-template [ngIf]="showUpTo >= 2">
      <div class="row mt-5">
        <div class="col-md-10 offset-md-1 text-center">
          <h4 class="mt-3 mb-2 lato font-weight-light text-no-transform">
            2) Add optional add-ons to your plan
          </h4>
          <p class="mb-3 sub-title-step">These services make your content shine.</p>
          <div *ngIf="priceListLoaded" class="row justify-content-md-center">
            <div
              class="col-md-3 p-2"
              [class.disabled-element]="changesScheduled()"
              *ngFor="let code of addOnCodes; let i = index">
              <div
                class="pricing-box _pricing-box-add-ons py-4 cursor-pointer"
                [class.selected]="subscriptionConfig.addOns[code]?.checked"
                [pass-event-to]="addOnRef">
                <h4><i class="fas fa-{{ addOnIcons[i] }}"></i><br />+{{ code }}</h4>
                <p class="mb-3">
                  <a href="javascript:void(0)" (click)="openEnhancementsModal($event, code)"
                    >Learn more</a
                  >
                </p>
                <custom-checkbox
                  #addOnRef
                  [(checked)]="subscriptionConfig.addOns[code].checked"
                  [disabled]="subscriptionConfig.addOns[code].disabled"
                  (checkedChange)="handleAddOnChange(code)">
                </custom-checkbox>
                <div class="add-on-price-box mt-1 d-flex align-items-center justify-content-center">
                  <div
                    *ngIf="
                      !this.subscriptionConfig.addOns['optimize'].checked || code != 'photo';
                      else photoIncluded
                    ">
                    <div class="small">starting at</div>
                    <div>
                      <span class="currency">{{ priceList.addOns[code]?.formattedValue }}</span
                      ><span class="per-month">/piece</span>
                    </div>
                  </div>
                  <ng-template #photoIncluded>
                    <div>Included!</div>
                  </ng-template>
                </div>
              </div>
            </div>
          </div>
          <!-- <div *ngIf="!quantityErrorMessage" class="row border p-3 mt-4 price-partial justify-content-md-center">
            <div class="col-12 col-sm-6 ml-auto">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-6 col-sm-auto label text-right">Subtotal: </div>
                <div class="col-5 col-sm-auto text-left ml-2"><span class="dollars">{{addOnsSubtotalFormattedValue}}</span></div>
              </div>
            </div>
            <div class="col-12 col-sm-auto mr-auto">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-6 col-sm-auto label text-right">Credits: </div>
                <div class="col-5 col-sm-auto text-left ml-2"><span class="chip">{{addOnsSubtotalCredits}}</span></div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </ng-template>
  </div>

  <div #section3>
    <ng-template [ngIf]="showUpTo >= 3">
      <div class="row mt-5">
        <div class="col text-center">
          <h4 class="mt-3 mb-2 lato font-weight-light text-no-transform">
            3) Get help managing the platform
          </h4>
          <p class="mb-3 sub-title-step">Our highest level of service.</p>
        </div>
      </div>

      <div *ngIf="priceListLoaded" class="row mt-3 mb-3">
        <div class="col-stack-mobile p-2 mx-auto">
          <div
            class="pricing-box d-flex flex-row cursor-pointer pr-3"
            [class.disabled-element]="changesScheduled()"
            [class.selected]="plusValetChecked"
            [pass-event-to]="plusValetRef">
            <div class="p-4">
              <custom-checkbox
                #plusValetRef
                [(checked)]="plusValetChecked"
                (checkedChange)="handlePlusValetChange()"></custom-checkbox>
            </div>
            <div class="py-4 text-left">
              <h4><i class="fas fa-bolt"></i> VERBLIO VALET</h4>
              <p>
                We do the work for you and save you time. A HubSpot Inbound-Certified account
                manager will help you get the most out of Verblio.
                <a href="javascript:void(0)" (click)="openValetModal($event)">Learn more</a>
              </p>
              <p>
                <span class="currency">{{ valetFormattedValue }}</span
                ><span class="per-month">/month </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div #section4>
    <ng-template [ngIf]="showUpTo >= 4">
      <div class="row mt-5">
        <div class="col-12 text-center">
          <h4 class="mb-2 lato font-weight-light text-no-transform">
            4) Choose how you want to pay
          </h4>
          <p class="sub-title-step">Save more with longer commitments.</p>
        </div>

        <div *ngIf="priceListLoaded" class="row col-12 justify-content-md-center">
          <div class="col-md-3 p-2">
            <div
              class="pricing-box billing-frequency py-4 cursor-pointer"
              [class.disabled-element]="changesScheduled()"
              [class.selected]="subscriptionConfig.durationInMonths == 1"
              [pass-event-to]="monthlyRef"
              [is-disabled]="monthlyDisabled">
              <h4>MONTHLY</h4>
              <div class="mb-2 small">
                cancel any month
                <p>&nbsp;</p>
              </div>
              <div>
                <custom-radio-button
                  #monthlyRef
                  name="term"
                  [value]="1"
                  [(selected)]="subscriptionConfig.durationInMonths"
                  [disabled]="monthlyDisabled"
                  (selectedChange)="handleTermChange($event)"></custom-radio-button>
              </div>
              <div class="mt-2">
                <span class="pricing-box month rounded-0 text-uppercase h5 shadow-none"
                  >&nbsp;</span
                >
              </div>
            </div>
          </div>

          <div class="col-md-3 p-2">
            <div
              class="pricing-box billing-frequency py-4 cursor-pointer"
              [class.disabled-element]="changesScheduled()"
              [class.selected]="subscriptionConfig.durationInMonths == 3"
              [pass-event-to]="quarterlyRef">
              <h4>QUARTERLY</h4>
              <div class="mb-2 small">
                commit for 3 months
                <p>paid monthly</p>
              </div>
              <div>
                <custom-radio-button
                  #quarterlyRef
                  name="term"
                  [value]="3"
                  [(selected)]="subscriptionConfig.durationInMonths"
                  (selectedChange)="handleTermChange($event)"></custom-radio-button>
              </div>
              <div class="mt-2">
                <span class="pricing-box quarterly rounded-0 text-uppercase h5 shadow-none"
                  >5% OFF</span
                >
              </div>
            </div>
          </div>

          <div class="col-md-3 p-2">
            <div
              class="pricing-box billing-frequency py-4 cursor-pointer"
              [class.disabled-element]="changesScheduled()"
              [class.selected]="subscriptionConfig.durationInMonths == 12"
              [pass-event-to]="annuallyRef">
              <h4>ANNUALLY</h4>
              <div class="mb-2 small">
                commit for 12 months
                <p>paid monthly</p>
              </div>
              <div>
                <custom-radio-button
                  #annuallyRef
                  name="term"
                  [value]="12"
                  [(selected)]="subscriptionConfig.durationInMonths"
                  (selectedChange)="handleTermChange($event)"></custom-radio-button>
              </div>
              <div class="mt-2">
                <span class="pricing-box annually rounded-0 text-uppercase h5 shadow-none"
                  >10% OFF</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
  </div>

  <div #section5>
    <ng-template [ngIf]="showUpTo >= 5">
      <div class="mt-5">
        <div class="col-12 text-center">
          <h4 class="mb-2 lato font-weight-light text-no-transform">5) Review your subscription</h4>
        </div>

        <subscription-review [summaryData]="summaryData"></subscription-review>
      </div>

      <div
        *ngIf="prevTotalCredits && customer.subscription?.state !== 'pending'"
        class="row justify-content-md-center mt-1">
        <div class="col-md-9 p-3">
          <p class="font-italic small border py-2 px-4">
            <span class="font-weight-bold">Need more content now?</span> You may order a la carte
            when making a content request.
          </p>
        </div>
      </div>

      <div style="display: inline-block" *ngIf="customerId && !showActivateButton">
        <p
          class="d-flex justify-content-center m-3 pt-10 pb-10"
          style="background: #fff0f0; border-radius: 4px; max-width: 400px; padding: 10px 16px">
          <i class="mr-2 align-self-center text-danger fas fa-exclamation-circle"></i>
          {{ errorMessage }}
        </p>
      </div>

      <div class="row mt-3 d-flex justify-content-center">
        <div class="row mb-3" *ngIf="customerId && actionButton == 'save'">
          <button
            type="submit"
            class="btn btn-primary"
            (click)="handleActivatePlanClick()"
            [disabled]="isSaveButtonDisabled || !showActivateButton">
            {{ saveButtonText + (isSaveButtonDisabled ? ' ...' : '') }}
          </button>
        </div>
      </div>

      <div class="row mt-5" *ngIf="customerId && actionButton">
        <div class="col text-center">
          <p class="small">
            {{ confirmationMessage3 }}, you agree to Verblio's
            <a [routerLink]="['/pages/privacy_policy']" target="_blank">privacy notice</a>
            and
            <a [routerLink]="['/pages/tos/customer']" target="_blank">terms of use</a>.
          </p>
        </div>
      </div>

      <div class="row mb-3" *ngIf="customerId && actionButton == 'cancel_scheduled'">
        <div class="col text-center">
          <button type="submit" class="btn btn-primary" [disabled]="isSaveButtonDisabled" (click)="handleCancelChanges()">
            {{"Cancel scheduled changes" + (isSaveButtonDisabled ? ' ...' : '')}}
          </button>
        </div>
      </div>
    </ng-template>
  </div>

  <div #section6 *ngIf="!customerId">
    <div class="row mt-4">
      <div class="col-12 text-center">
        <h4 class="mb-2 lato font-weight-light text-no-transform">Sign up with this plan</h4>
        <section class="d-flex flex-wrap justify-content-center">
          <div class="form-groupt pr-0 mb-2">
            <input
              type="email"
              class="form-control"
              placeholder="Enter your email"
              [formControl]="email"
              [ngClass]="{ 'is-invalid': email.invalid && email.touched }"
              required />
            <div *ngIf="email.errors && email.touched" class="invalid-feedback">
              This field can't be blank
            </div>
          </div>
          <div class="form-group pl-0 ml-2">
            <button type="button" class="btn btn-primary" (click)="saveAndContinue()">
              Save + Continue
            </button>
          </div>
        </section>
      </div>
    </div>
  </div>

  <div class="row mb-3 mt-3" *ngIf="showUpTo < 5">
    <div class="col text-center">
      <button
        type="submit"
        class="btn btn-secondary"
        (click)="handleNextClick()"
        [disabled]="!nextButtonIsActive">
        Next
      </button>
    </div>
  </div>

  <div
    class="row mt-5"
    *ngIf="
      !customer?.scheduledSubscription &&
      customer?.subscription?.state == 'active' &&
      !customer?.subscription?.scheduledToCancelAt
    ">
    <div class="col text-center">
      <p class="mb-3">
        <a href="/customers/{{ customer?.id }}/subscription">Cancel this subscription</a>
      </p>
    </div>
  </div>
</div>
